export default __webpack_public_path__ + "static/media/goshen110.d85f2ffe.jpg";